<template>
  <!-- 各子项目建设进度规划 -->
  <div class="page">
    <div class="paginations" :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
      <div class="table-search-box">
        <el-form :inline="true" :model="formInSearch" class="demo-form-inline">
          <el-form-item label="子项目名称：">
            <el-input size="small" v-model="formInSearch.name" placeholder="请输入子项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="getList('')"></i>
              <i class="pointer el-icon-refresh-left" @click="resetting"></i>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_box">
        <el-table :data="tableList" style="width: 100%">
          <el-table-column prop="index" label="序号" align='center'>
          </el-table-column>
          <el-table-column prop="name" label="子项目名称" align='center'>
          </el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scope">
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row,1)"></i>
              <i class="icona icon-download" title="下载" @click="edit(scope.row,2)"></i>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <pageNumber :paginations="7" :pageNum="pageDto.pageNum" :pageSize="pageDto.pageSize" :total="total" :jumpTo="jumpTo" @currentChange="getList"></pageNumber>
    </div>

    <!-- 编辑各子项目建设进度规划 -->
    <!-- 添加弹窗 -->
    <el-dialog :title="uploadBox.title" :visible.sync="uploadBox.show" :modal="uploadBox.isDownload?false:true" :close-on-click-modal="false" width="900px" class="pop_up" append-to-body :before-close="handleClose" :class="uploadBox.isDownload?'isDownload':''">
      <div class="planTable">
        <table id="out-table" width='100%' border="1" bordercolor="#4B557C" style="color: #fff;" cellpadding='0' cellspacing='0' align='center' v-if="secondTableList.length > 1">
          <tr>
            <td colspan="5">绩效指标</td>
          </tr>
          <tr>
            <td rowspan="2">一级指标</td>
            <td rowspan="2">二级指标</td>
            <td rowspan="2">三级指标</td>
            <td colspan="2">指标值</td>
          </tr>
          <tr>
            <td style="text-align:center;">监测平台值</td>
            <td class="alignment">
              <span>任务目标值</span>
              <span>（可根据实际情况修改）</span>
            </td>
          </tr>
          <tr style="text-align: center;">
            <td rowspan="26">1.产出指标</td>
            <td rowspan="7">1.1数量指标</td>
            <td class="boldTd">*1.1.1素材资源数量</td>
            <td>{{secondTableList[0].realValue}}</td>
            <td></td>
          </tr>
          <tr>
            <td class="tableIndent">1.1.1.1视频类素材资源(个) </td>
            <td style="text-align:center;">{{secondTableList[1].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[1].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.1.1.2动画类素材资源(个) </td>
            <td style="text-align:center;">{{secondTableList[2].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[2].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.1.1.3虚拟仿真类素材资源(个) </td>
            <td style="text-align:center;">{{secondTableList[3].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[3].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.1.1.4微课类素材资源(个)</td>
            <td style="text-align:center;">{{secondTableList[4].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[4].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.1.1.5其他非文本类素材资源(个)</td>
            <td style="text-align:center;">{{secondTableList[5].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[5].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <!-- <td class="boldTd">*1.1.2课程数量 </td> -->
            <!-- <td style="text-align:center;">{{secondTableList[6].realValue}}</td> -->
            <!-- <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[6].targetValue" placeholder=""></el-input>
            </td> -->
          </tr>
          <tr>
            <td rowspan="19">1.2质量指标</td>
            <td class="boldTd">1.2.1素材资源质量</td>
            <td>——————</td>
            <td>————————————</td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.1原创资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[6].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[6].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.2视频类素材资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[7].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[7].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.3动画类素材资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[8].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[8].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.4虚拟仿真类素材资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[9].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[9].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.5微课类素材资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[10].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[10].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.6其它非文本类素材资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[11].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[11].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.1.7活跃资源占比（%）</td>
            <td style="text-align:center;">{{secondTableList[12].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[12].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="boldTd">1.2.3用户数量与活跃度</td>
            <td>——————</td>
            <td>————————————</td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.1学生用户数量(个)</td>
            <td style="text-align:center;">{{secondTableList[13].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[13].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.1.1建设单位在校学生用户数量（个）</td>
            <td style="text-align:center;">{{secondTableList[14].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[14].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.1.2建设单位在校学生活跃用户数量(个)</td>
            <td style="text-align:center;">{{secondTableList[15].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[15].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.1.3建设单位在校学生活跃用户占比（%）</td>
            <td style="text-align:center;">{{secondTableList[16].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[15].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.2教师用户数量(个)</td>
            <td style="text-align:center;">{{secondTableList[17].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[17].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.2.1建设单位教师用户数量（个）</td>
            <td style="text-align:center;">{{secondTableList[18].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[18].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr style="text-align:center;">
            <td class="tableIndent">1.2.3.2.2建设单位教师活跃用户数量(个)</td>
            <td>{{secondTableList[18].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[19].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr style="text-align:center;">
            <td class="tableIndent">1.2.3.2.3建设单位教师活跃用户占比（%）</td>
            <td>{{secondTableList[18].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[20].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.3企业员工用户数量(个)</td>
            <td style="text-align:center;">{{secondTableList[21].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[21].targetValue" placeholder=""></el-input>
            </td>
          </tr>
          <tr>
            <td class="tableIndent">1.2.3.4社会学习者用户数量(个)</td>
            <td style="text-align:center;">{{secondTableList[22].realValue}}</td>
            <td>
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="secondTableList[22].targetValue" placeholder=""></el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="determine">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <!-- <loading class="loading_box" v-if="this.$store.state.loading"></loading> -->
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue' //分页
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
export default {
  components: {
    pageNumber
  },
  data() {
    return {
      formInSearch: {
        name: '',
      },
      tableList: [],
      pageDto: {
        pageNum: 1,//当前显示的页面页码数
        pageSize: 10, //一页多少条数据
      },
      total: 0,
      jumpTo: 1,

      // 弹窗
      uploadBox: {
        title: '编辑各子项目建设进度规划',
        show: false,
      },
      secondTableList: [],
      editName: '',
      isDownload: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取表格数据
    getList(query) {
      this.pageDto.pageNum = query ? query : 1
      this.jumpTo = query ? query : 1
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionPlanList, {
        pageDto: this.pageDto,
        type: 2,
        name: this.formInSearch.name
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          for (let i = 0; i < res.data.list.length; i++) {
            var index = 0
            if (this.pageDto.pageNum == 1) {
              index = i + 1
            } else {
              index = i + 1 + ((this.pageDto.pageNum - 1) * 10)
            }
            arrList.push({
              index: index,
              name: res.data.list[i]
            })
          }
          this.tableList = arrList
          this.total = res.data.total
        }
      });
    },
    // 重置
    resetting() {
      this.formInSearch.name = ''
      this.getList('')
    },
    // 编辑
    edit(row, type) {
      this.uploadBox.isDownload = false
      this.editName = row.name
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionPlan, {
        type: 2,
        name: row.name
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {
                baseValue: null,
                number: res.data[i].number,
                realValue: '',
                targetValue: null
              }
            }
            if (!res.data[i].value.realValue) {
              res.data[i].value.realValue = ''
            }
            arrList.push({
              name: res.data[i].name,
              number: res.data[i].number,
              realValue: res.data[i].value.realValue,
              targetValue: res.data[i].value.targetValue,
            })
          }
          this.secondTableList = arrList

          console.log(this.secondTableList, 'ssssssssssssssssss');

          this.uploadBox.show = true
          this.$store.commit('modifyVague', true);

          if (type == 2) {
            this.uploadBox.isDownload = true
            this.$nextTick(() => {
              var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
              const wscols = [ // 定义每列的宽度 我这里是16列
                { wch: 19 },
                { wch: 19 },
                { wch: 50 },
                { wch: 19 },
                { wch: 19 },
              ]
              wb.Sheets[wb.SheetNames[0]]['!cols'] = wscols
              /* 获取二进制字符串作为输出 */
              var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array",
                align: 'center',
                valign: 'vcenter',
              });
              try {
                FileSaver.saveAs(
                  //Blob 对象表示一个不可变、原始数据的类文件对象。
                  //Blob 表示的不一定是JavaScript原生格式的数据。
                  //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                  //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                  new Blob([wbout], { type: "application/octet-stream" }),
                  //设置导出文件名称
                  `${sessionStorage.getItem('zykName')}_${row.name}.xlsx`
                );
              } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
              }
              this.uploadBox.show = false
              this.$store.commit('modifyVague', false);
              return wbout;
            })
          }
        }
      }).catch(_ => {
        this.$store.commit('isLoading', false);
      });
    },
    // 下载
    // download(row) {
    //   this.edit(row)
    //   this.exportExcel(row)
    // },

    // exportExcel(row) {
    //   var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
    //   const wscols = [ // 定义每列的宽度 我这里是16列
    //     { wch: 19 },
    //     { wch: 19 },
    //     { wch: 50 },
    //     { wch: 19 },
    //     { wch: 19 },
    //   ]
    //   wb.Sheets[wb.SheetNames[0]]['!cols'] = wscols
    //   /* 获取二进制字符串作为输出 */
    //   var wbout = XLSX.write(wb, {
    //     bookType: "xlsx",
    //     bookSST: true,
    //     type: "array",
    //     align: 'center',
    //     valign: 'vcenter',
    //   });
    //   try {
    //     FileSaver.saveAs(
    //       //Blob 对象表示一个不可变、原始数据的类文件对象。
    //       //Blob 表示的不一定是JavaScript原生格式的数据。
    //       //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
    //       //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
    //       new Blob([wbout], { type: "application/octet-stream" }),
    //       //设置导出文件名称
    //       `${sessionStorage.getItem('zykName')}_${row.name}.xlsx`
    //     );
    //   } catch (e) {
    //     if (typeof console !== "undefined") console.log(e, wbout);
    //   }
    //   return wbout;
    // },

    // 弹窗中的确定修改
    determine() {
      this.$axios.post(this.$apiurls.updateConstructionProgressOfParticipatingInstitutionPlan, {
        type: 2,
        name: this.editName,
        constructionDtos: this.secondTableList,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data == 1 || res.data == null) {
            this.$message({
              message: '编辑成功！',
              type: 'success'
            });
            this.uploadBox.show = false
            this.$store.commit('modifyVague', false);
          } else {
            this.$message.error('编辑失败！')
          }
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.uploadBox.show = false
      this.$store.commit('modifyVague', false);
    },
  }
}
</script>



<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

// 弹窗
.boldTd {
  font-weight: 700;
  font-size: 16px;
  text-align: left;
  text-indent: 15px;
}

.tableIndent {
  text-align: left;
  text-indent: 35px;
  font-size: 15px;
}

.alignment {
  display: flex;
  flex-flow: column;
}

.tx-center {
  margin-top: 10px;
}

.planTable {
  max-height: 500px;
  overflow: auto;
}

.planTable table td {
  padding: 5px;
  color: #fff;
}
</style>